"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.askInitialisation = askInitialisation;
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/07/17
 */
const internal_1 = require("./internal");
const const_1 = require("./const");
function askInitialisation() {
    const message = (0, internal_1.getInternalMessage)({
        name: const_1.SEND_INTERNAL_MESSAGE.ASK_INITIALISATION,
        value: { origin: location.origin },
    });
    window.parent.postMessage(message, "*"); // NOSONAR
}
//# sourceMappingURL=ask.js.map